import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import { makeBoxBuyConnectIntegration } from '../../models/Integration/makeBoxBuyIntegration'

function* createBoxBuyIntegration() {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateBoxBuyIntegration)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, makeBoxBuyConnectIntegration)),
    ])

    const result = yield call(service)

    const redirectUrl = result?.items?.url
    if (redirectUrl) {

      window.location.href = redirectUrl
      return
    }

    yield Effects.delay(500)
    yield Effects.put({ type: IntegrationAction.GET_BOXBUY_STATUS })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(
    IntegrationAction.CreateBoxBuyIntegration,
    createBoxBuyIntegration,
  )
}
